import classnames from 'classnames'

import { Alert, AlertProps, Button, IconBatteryCharging } from '@/components'

type BatteryInfoAlertProps = AlertProps

export const BatteryInfoAlert = ({
    className,
    ...props
}: BatteryInfoAlertProps) =>
    <Alert
        type="custom"
        className={classnames(className, 'bg-white font-body')}
        icon={<div className="w-10 h-10 rounded-full bg-purple-50 flex justify-center items-center">
            <div className="w-8 h-8 rounded-full bg-purple-100 flex justify-center items-center stroke-purple-700">
                <IconBatteryCharging/>
            </div>
        </div>}
        {...props}
    >
        <div className="flex gap-2 flex-col lg:flex-row items-start lg:items-center justify-between grow">
            <p className="leading-6">
                Interested in selling our <span className="font-semibold">New Battery Monitoring & Warranty
                        Product</span>? <br/>
                Learn More about our Certified Installer program!
            </p>
            <Button
                design="btn-secondary-gray"
                href="https://www.solarinsure.com/battery"
                className="whitespace-nowrap"
                size="btn-sm"
            >
                Learn More
            </Button>
        </div>
    </Alert>
